import {
  CREATE_USER_ERROR,
  CREATE_USER_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,
  FETCH_USERS_ERROR,
  FETCH_USERS_SUCCESS,
  FETCH_ONE_USER_SUCCESS,
  FETCH_ONE_USER_ERROR,
  UPDATE_USER_ERROR,
  UPDATE_USER_SUCCESS,
} from "./types";

const initialState = {
  loading: false,
  data: [],
  error: "",
  selectedUser: null, // Add a new state for selected user
};

export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: "",
      };
    case FETCH_USERS_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload,
      };

    case FETCH_ONE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedUser: action.payload,
        error: "",
      };
    case FETCH_ONE_USER_ERROR:
      return {
        ...state,
        loading: false,
        selectedUser: null,
        error: action.payload,
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: "",
      };
    case CREATE_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        data: state.data.map((user) =>
          user._id === action.payload._id ? action.payload : user
        ),
        loading: false,
        error: "",
      };
    case UPDATE_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((user) => user._id !== action.payload),
        error: "",
      };
    case DELETE_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
